var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCarDefault = function SvgCarDefault(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m26.892 4.885 1.696 5.915H32v2.6h-2.667v9.1c0 .69-.282 1.35-.782 1.837-.5.488-1.177.762-1.884.763V29H24v-3.9H8V29H5.333v-3.9a2.705 2.705 0 0 1-1.884-.763 2.57 2.57 0 0 1-.782-1.837v-9.1H0v-2.6h3.375l1.733-5.914c.161-.542.498-1.02.96-1.36A2.724 2.724 0 0 1 7.673 3h16.654a2.724 2.724 0 0 1 1.604.526c.463.34.8.817.96 1.359Zm-2.564.715H7.673l-1.905 6.5h20.464l-1.904-6.5Zm2.339 16.9v-2.6H24v-2.6h2.667v-2.6H5.333v2.6H8v2.6H5.333v2.6h21.334ZM12 17.3h8v2.6h-8v-2.6Z",
    fill: "currentColor"
  })));
};
export default SvgCarDefault;